import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivateRoute from "./Common/Configurations/PrivateRoute";
import Login from "./Authentication/Login";
import ChangePassword from "./Components/Master/ChangePassword";
import Unauthorized from "./Common/Unauthorized";
import Dashboard from "./Components/Dashboards/Dashboard";
import CompanyProfile from "./Components/Master/CompanyProfile";
import Branch from "./Components/Master/Branch";
import Users from "./Components/Master/Users";
import Customer from "./Components/Master/Customer";
import Account from "./Components/Master/Account";
import TaxRate from "./Components/Master/TaxRate";
import ExchangeRateComponent from "./Components/Master/ExchangeRate";
import BankAccount from "./Components/Master/BankAccounts";
import Vendor from "./Components/Master/Vendor";
import Industry from "./Components/Master/Industry";
import IndustryAccount from "./Components/Master/IndustryAccount";
import AccountType from "./Components/Master/AccountType";
import AccountItem from "./Components/Master/AccountItem";
import CustomerReport from "./Components/Reports/CustomerReport";
import ExpenseReport from "./Components/Reports/ExpenseReport";
import VendorReports from "./Components/Reports/VendorReport";
import SalesReports from "./Components/Reports/SalesReports";
import PurchaseReports from "./Components/Reports/PurchaseReports";
import InvoiceReports from "./Components/Reports/InvoiceReport";
import SaleInvoice from "./Components/Invoices/SaleInvoice";
import EditSaleInvoice from "./Components/Invoices/EditSaleInvoice";
import SaleView from "./Components/Invoices/SaleView";
import SaleList from "./Components/Invoices/SaleList";
import Item from "./Components/Master/Item";
import PurchaseInvoice from "./Components/Invoices/PurchaseInvoice";
import PurchaseList from "./Components/Invoices/PurchaseList";
import EditPurchaseInvoice from "./Components/Invoices/EditPurchaseInvoice";
import PurchaseView from "./Components/Invoices/PurchaseView";
import ExpenseInvoice from "./Components/Invoices/ExpenseInvoice";
import ExpenseList from "./Components/Invoices/ExpenseList";
import ExpenseView from "./Components/Invoices/ExpenseView";
import EditExpenseInvoice from "./Components/Invoices/EditExpenseInvoice";
import JournalReport from "./Components/AccoutingReports/JournalReport";
import LedgerReport from "./Components/AccoutingReports/LedgerReport";
import TrialBalancereport from "./Components/AccoutingReports/TrialBalanceReport";
import ProfitLoss from "./Components/AccoutingReports/ProfitLossReport";
import Cheque from "./Components/Master/Cheque";
import ConfirmEmail from "./Authentication/ConfirmEmail.jsx";
import TaxInformation from "./Authentication/TaxInformation.jsx";
import RegistrationPending from "./Authentication/RegistrationPending.jsx";
import SaasRegister from "./Authentication/SaasRegistration.jsx";
import ForgotPassword from "./Authentication/ForgotPassword.jsx";
import { RESETPASSWORD } from "./Common/Configurations/APIConfig.jsx";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route
          element={<PrivateRoute roles={["ADMIN", "SUPERADMIN"]} />}
        ></Route>
        <Route path="/register" element={<SaasRegister />} />
        <Route path="/tax-information" element={<TaxInformation />} />
        <Route path="/registration-pending" element={<RegistrationPending />} />
        <Route path="/confirm-email" element={<ConfirmEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/resetpassword" element={<RESETPASSWORD />} />
        <Route path="/changepassword" element={<ChangePassword />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/companyprofile" element={<CompanyProfile />} />
        <Route path="/branchs" element={<Branch />} />
        <Route path="/users" element={<Users />} />
        <Route path="/customers" element={<Customer />} />
        <Route path="/accounts" element={<Account />} />
        <Route path="/taxrates" element={<TaxRate />} />
        <Route path="/exchangerates" element={<ExchangeRateComponent />} />
        <Route path="/bankaccounts" element={<BankAccount />} />
        <Route path="/vendors" element={<Vendor />} />
        <Route path="/industries" element={<Industry />} />
        <Route path="/industryaccounts" element={<IndustryAccount />} />
        <Route path="/accounttypes" element={<AccountType />} />
        <Route path="/items" element={<Item />} />
        <Route path="/accountitems" element={<AccountItem />} />
        <Route path="/saleinvoice" element={<SaleInvoice />} />
        <Route
          path="/editsaleinvoice/:invoiceId"
          element={<EditSaleInvoice />}
        />
        <Route path="/sale/view/:invoiceId" element={<SaleView />} />
        <Route path="/salelist" element={<SaleList />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/customerreports" element={<CustomerReport />} />
        <Route path="/expensereports" element={<ExpenseReport />} />
        <Route path="/vendorreports" element={<VendorReports />} />
        <Route path="/salesreports" element={<SalesReports />} />
        <Route path="/purchasereports" element={<PurchaseReports />} />
        <Route path="/invoicereports" element={<InvoiceReports />} />

        <Route path="/purchaseinvoice" element={<PurchaseInvoice />} />
        <Route path="purchaselist" element={<PurchaseList />} />
        <Route path="/purchase/view/:invoiceId" element={<PurchaseView />} />
        <Route
          path="/editpurchaseinvoice/:invoiceId"
          element={<EditPurchaseInvoice />}
        />
        <Route path="/expenseinvoice" element={<ExpenseInvoice />} />
        <Route path="expenselist" element={<ExpenseList />} />
        <Route path="/expense/view/:invoiceId" element={<ExpenseView />} />
        <Route
          path="/editexpenseinvoice/:invoiceId"
          element={<EditExpenseInvoice />}
        />
        <Route path="/cheque" element={<Cheque />} />
        <Route path="/journalreports" element={<JournalReport />} />
        <Route path="/ledgerreports" element={<LedgerReport />} />
        <Route path="/trialbalancereports" element={<TrialBalancereport />} />
        <Route path="/profitlossreports" element={<ProfitLoss />} />
      </Routes>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;
